module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-filter"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('ul', {
    staticClass: "link-filter"
  }, [_c('li', [_c('ul', _vm._l((_vm.sortings), function(s) {
    return _c('li', [(s.id == _vm.ssorting) ? _c('span', [_vm._v(_vm._s(s.name))]) : _vm._e(), _vm._v(" "), (s.id != _vm.ssorting) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setSorting(s.id)
        }
      }
    }, [_vm._v(_vm._s(s.name))]) : _vm._e()])
  }))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link toggle-dds",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showFilter = !_vm.showFilter
      }
    }
  }, [_vm._v(_vm._s(_vm.texts.filter) + " "), _c('span', {
    staticClass: "icon-down-open-mini"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-values"
  }, [(_vm.showFilter) ? _c('div', {
    staticClass: "dds"
  }, [(_vm.brands != null && _vm.useBrandFilter) ? _c('div', [_c('p', {
    staticClass: "h3"
  }, [_vm._v(_vm._s(_vm.texts.manufacturer))]), _vm._v(" "), _vm._l((_vm.brands), function(b) {
    return _c('div', {
      key: b.id,
      staticClass: "checkbox checkable-small"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.sbrand),
        expression: "sbrand"
      }],
      attrs: {
        "type": "checkbox",
        "name": "sf-brand"
      },
      domProps: {
        "value": b,
        "checked": Array.isArray(_vm.sbrand) ? _vm._i(_vm.sbrand, b) > -1 : (_vm.sbrand)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.sbrand,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = b,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.sbrand = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.sbrand = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.sbrand = $$c
          }
        }, function($event) {
          $event.preventDefault();
          return _vm.refreshFilter($event)
        }]
      }
    }), _c('span', {
      class: {
        'font-bold': (b.name == 'Adast' || b.name == 'Roland' || b.name == 'Heidelberg' || b.name == 'KBA' || b.name == 'Polly')
      }
    }, [_vm._v(_vm._s(b.name))])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "h3"
  }, [_vm._v(_vm._s(_vm.texts.yearOfProduction))]), _vm._v(" "), _vm._l((_vm.years), function(y) {
    return _c('div', {
      key: y.id,
      staticClass: "checkbox checkable-small"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.syear),
        expression: "syear"
      }],
      attrs: {
        "type": "checkbox",
        "name": "sf-year"
      },
      domProps: {
        "value": y.id,
        "checked": Array.isArray(_vm.syear) ? _vm._i(_vm.syear, y.id) > -1 : (_vm.syear)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.syear,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = y.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.syear = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.syear = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.syear = $$c
          }
        }, function($event) {
          $event.preventDefault();
          return _vm.refreshFilter($event)
        }]
      }
    }), _c('span', [_vm._v(_vm._s(y.name))])])])
  })], 2), _vm._v(" "), (_vm.useFormatFilter) ? _c('div', [_c('p', {
    staticClass: "h3"
  }, [_vm._v(_vm._s(_vm.texts.format))]), _vm._v(" "), _vm._l((_vm.formats), function(f) {
    return _c('div', {
      key: f.id,
      staticClass: "checkbox checkable-small"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.sformat),
        expression: "sformat"
      }],
      attrs: {
        "type": "checkbox",
        "name": "sf-format"
      },
      domProps: {
        "value": f.id,
        "checked": Array.isArray(_vm.sformat) ? _vm._i(_vm.sformat, f.id) > -1 : (_vm.sformat)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.sformat,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = f.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.sformat = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.sformat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.sformat = $$c
          }
        }, function($event) {
          $event.preventDefault();
          return _vm.refreshFilter($event)
        }]
      }
    }), _c('span', [_vm._v(_vm._s(f.name))])])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.showFilter && _vm.useBrandFilter) ? _c('div', {
    staticClass: "dds-selected"
  }, [_vm._l((_vm.sbrand), function(b, index) {
    return _c('span', {
      staticClass: "remove-item",
      on: {
        "click": function($event) {
          _vm.unselectBrand(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(b.name) + " "), _c('span', {
      staticClass: "icon-cancel-strong"
    })])
  }), _vm._v(" "), _vm._l((_vm.syear), function(y, index) {
    return _c('span', {
      staticClass: "remove-item",
      on: {
        "click": function($event) {
          _vm.unselectYear(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getYearName(y)) + " "), _c('span', {
      staticClass: "icon-cancel-strong"
    })])
  }), _vm._v(" "), _vm._l((_vm.sformat), function(f, index) {
    return _c('span', {
      staticClass: "remove-item",
      on: {
        "click": function($event) {
          _vm.unselectFormat(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getFormatName(f)) + " "), _c('span', {
      staticClass: "icon-cancel-strong"
    })])
  })], 2) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1f8b340","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Content/Modern/js/vue/_search-filter.vue
// module id = 121
// module chunks = 1